import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_TIME_SINK_IDS } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'A "What\'s taking up your time" chip is toggled',
  name: 'agent_onboarding_interest_selected',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The time-sink chip that was toggled',
      name: 'interest',
      required: true,
      type: 'enum',
      values: [...AGENT_ONBOARDING_TIME_SINK_IDS],
    },
    {
      description: 'Whether the chip is selected after the toggle',
      name: 'selected',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
